define('shared/initializer/form/newHouseAdapters/mixins/MemberRedemptionCodeConsumable',[ 
    './OrderInfoStorable',
    './OffersInfoStorable',
    './PaymentSuccessHandlable',
    '../../adapters/mixins/Redirectable',
    'shared/lib/RSVP',
    'shared/initializer/form/constants',
    'shared/util/checkout/checkout',
    'shared/util/state',
    'shared/util/state/adapters/order',
    'shared/my/accessToken'
],
function ( 
    OrderInfoStorable,
    OffersInfoStorable,
    PaymentSuccessHandlable,
    Redirectable,
    RSVP, 
    constants,
    checkoutUtil,
    state,
    orderAdapter,
    myAccessToken
) {
    'use strict';

    function consumeRedemptionCode(){
        var me = this;
        return me.redemptionCode.consume();
    }

    function consume() {
        var me = this;
        var orderInfo;
        var offerId;
        return RSVP.resolve()
        .then(function(){
            return consumeRedemptionCode.apply(me, arguments);
        })
        .then(function(oi){
            if (!oi || !oi.Order_id) {
                return;
            }

            return RSVP.resolve()
                .then(function(){
                    if (oi.Items && oi.Items[0] && oi.Items[0].Offer_id) {
                        offerId = oi.Items[0].Offer_id;
                    }
                    orderInfo = oi;
                    return state.adapters.add(orderAdapter);
                })
                .then(function(){
                    return state.push(constants.State.OrderOfferId, offerId);
                })
                .then(function(){
                    return orderInfo;
                });
        });
    }

    function InternalMixin() {

    }

    InternalMixin.prototype.doPageLoad = function() {
        var me = this;
        return myAccessToken.get()
            .then(function(accessToken){
                if (!accessToken) {
                    return;
                }

                return consume.apply(me)
                    .then(function(oi){
                        if (!oi || !oi.Order_id) {
                            return;
                        }

                        return Redirectable.prototype.doAfterSubmit.apply(me)
                            .then(function(){
                                var err = new Error('Redirecting...');
                                err.type = 'redirect';
                                return RSVP.reject(err);
                            });
                    });
            });
    };

    InternalMixin.prototype.doBeforeRedirect = consume;

    function Ctor(){
        var me = this;
        me.mixin(
            InternalMixin,
            OrderInfoStorable,
            OffersInfoStorable,
            PaymentSuccessHandlable
        );
    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;

        if (!me.redemptionCode) {
            throw new Error('HasRedemptionUtil mixin is not instantiated.');
        }
    };

    return Ctor;
});
